export const unclusteredPointLayer: any = {
  id: 'unclustered-point',
  type: 'symbol',
  source: 'earthquakes',
  layout: {
    'icon-image': ['get', 'icon'],
    'icon-size': 0.5,
    'icon-allow-overlap': true,
    'text-field': ['get', 'price'],
    'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
    'text-size': 12,
    'text-offset': [0, -0.7],
    'text-anchor': 'top',
    'text-allow-overlap': true,
    "symbol-sort-key": ["get", "sortKey"], // ✅ this controls z-index
    "symbol-z-order": "auto" // or "viewport-y" for vertical stacking
  },
  paint: {
    'text-color': '#f5f5f5',
    // 'text-halo-color': '#ffffff',
    'text-halo-width': 1,
  },
}

export const blackPinLayer: any = {
  id: 'black-pin-layer',
  type: 'symbol',
  source: 'blackPins',
  layout: {
    'icon-image': ['get', 'icon'],
    "icon-size": 1.1,
    "icon-allow-overlap": false,
    "text-field": ["get", "price"],
    "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
    "text-size": 13,
    "text-offset": [0, -0.8],
    'text-anchor': 'top',
    'text-allow-overlap': false,
    "symbol-sort-key": ["get", "sortKey"],
    "symbol-z-order": "auto"
  },
  paint: {
    'text-color': '#ffffff',
    'text-halo-width': 1,
  },
}
